import { PropsWithChildren } from "react";
const styles = new Proxy({"UseCase":"UseCase-346db","Text":"Text-346db"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const UseCase = ({
  spot,
  title,
  description,
}: PropsWithChildren<{ spot: string; title: string; description: string }>) => (
  <div className={styles.UseCase}>
    <div className={styles.Text}>
      <span>{spot}</span>
      <h5 className="m-0">{title}</h5>

      <p>{description}</p>
    </div>
  </div>
);

export default UseCase;
